import * as React from "react";
export default React.memo(function SvgComment(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" role="presentation" {...props}><path d="M13.23 2H2.77A1.77 1.77 0 0 0 1 3.77v7.44A1.77 1.77 0 0 0 2.77 13H3v3l4.16-3h6.06A1.77 1.77 0 0 0 15 11.21V3.77A1.77 1.77 0 0 0 13.23 2Zm.37 9.21a.38.38 0 0 1-.37.37H2.77a.38.38 0 0 1-.37-.37V3.77a.38.38 0 0 1 .37-.37h10.46a.38.38 0 0 1 .37.37Z" style={{
      fillRule: "evenodd"
    }} /></svg>;
});